// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"styles_inputContainer__AS5en","inputLabel":"styles_inputLabel__3FQ6E"};